<template>
  <Modal
    buttons-class="justify-center"
    header-class="q-pa-md"
    hide-close-button
    :modal-style="{ maxWidth: '350px' }"
    offset-menu
    persistent="persistent"
    :title="
      $t(
        'modals.confirm_instant_insights_dashboard_duplicate_modal.too_many_dashboards'
      )
    "
    @close="$emit('cancel')"
  >
    <div class="text-center">
      <i18n-t
        keypath="modals.confirm_instant_insights_dashboard_duplicate_modal.warning_sentence"
        scope="global"
      >
        <template #dashboardName>
          <i>{{ dashboardToBeClosed.name }}</i>
        </template>
      </i18n-t>
      <div
        v-if="dashboardToBeClosed.isDirty()"
        class="q-pt-md"
      >
        {{
          $t(
            "modals.confirm_instant_insights_dashboard_duplicate_modal.unsaved_warning"
          )
        }}
      </div>
    </div>
    <template #buttons>
      <BaseButton
        color="secondary"
        :label="$t('global.cancel')"
        new-design
        @click="cancel"
      />
      <BaseButton
        :color="theme"
        :label="$t('global.ok')"
        new-design
        @click="confirm"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import InstantInsightsReport from "shared/resources/InstantInsightsReport";

export default {
  name: "ConfirmInstantInsightsDashboardDuplicateModal",
  components: {
    BaseButton,
    Modal,
  },
  props: {
    dashboardToBeClosed: {
      type: InstantInsightsReport,
      required: true,
    },
  },
  emits: ["cancel", "close", "confirm"],
  computed: {
    theme() {
      return this.dashboardToBeClosed.isDirty() ? "danger" : "primary";
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.streem-modal2-header) {
  text-align: center;
}

:deep(.streem-modal2) {
  width: auto !important;
  margin: 0 auto !important;
}

:deep(.streem-modal2-buttons) {
  border-top: none !important;
  display: flex;
  padding: var(--s-spacing-lg);
  padding-top: 0;
  gap: var(--s-spacing-lg);
  justify-content: center;
}

:deep(.base-button) {
  white-space: nowrap;
}
</style>
